import { useTenantDataOptional } from "contexts/tenant";
import { FeatureFlag } from "src/store/api/generatedApi";

export const useIsBehindFeatureFlag = (featureFlag: FeatureFlag) => {
  const { feature_flags: tenantFeatureFlags } = useTenantDataOptional();
  if (tenantFeatureFlags === undefined) {
    return false;
  }
  return tenantFeatureFlags.includes(featureFlag);
};
